import axios from "axios";
import { siteIP } from "../../util/backendUtilities";

import Button from "../Button";
import { sendEventRegEmail } from "../emailJS/EmailJS";

import { formIsValid, isInvalidInput } from "../forms/formValidation";

const RegisterButton = (props) => {
  const {
    registrantData,
    didComplete,
    setIsLoading,
    setSubmitMessage,
    isDisabled,
  } = props;

  const submitHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const inputsInvalidityArr = [
      isInvalidInput(registrantData.firstName, "text"),
      isInvalidInput(registrantData.lastName, "text"),
      isInvalidInput(registrantData.email, "email"),
      isInvalidInput(registrantData.phone, "phone"),
      isInvalidInput(registrantData.company, "text"),
    ];
    if (formIsValid(inputsInvalidityArr)) {
      axios
        .post(`${siteIP}/event-register`, registrantData)
        .then((res) => {
          setIsLoading(false);
          sendEventRegEmail(registrantData);
          setSubmitMessage(
            <div>
              <h2 style={{ color: "green" }}>{res.data}</h2>
              <p style={{ textAlign: "center" }}>
                A confirmation email has been sent
              </p>
            </div>
          );
          didComplete(true);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err);
          setSubmitMessage(
            <h2 style={{ color: "red" }}>{err.response.data}</h2>
          );
        });
    } else {
      setIsLoading(false);
      alert("Please fill out all information correctly and resubmit");
    }

    //* IF THE EVENT IS A CONVENTION -
    //* DETERMINE IF CERTAIN SPONSORSHIPS NEED TO BE
    //* SET AS COMPLETED IN DATABASE TO DISABLE SELECTION
    //* ON FRONT END.

    if (registrantData.event.event_type === "CONVENTION") {
      registrantData.customInputs.Optional_Sponsorships.forEach(
        (sponsorship) => {
          const notifyBackend = (obj) => {
            axios.post(`${siteIP}/event-update`, obj);
          };

          //* IF HOSPITALITY SPONSORSHIP
          if (sponsorship.includes("Hospitality")) {
            const days = sponsorship.split("").filter((x) => Number(x));

            const obj = {
              days: days,
              eventID: registrantData.eventID,
              sponsorType: "Hospitality",
            };

            notifyBackend(obj);
          }
          //* IF BREAKFAST SPONSORSHIP
          if (sponsorship.includes("Breakfast")) {
            if (sponsorship.includes("Breakfast")) {
              const days = sponsorship.split("").filter((x) => Number(x));

              const obj = {
                days: days,
                eventID: registrantData.eventID,
                sponsorType: "Breakfast",
              };

              notifyBackend(obj);
            }
          }
          //* OTHER SPONSORSHIPS
          const obj = {
            days: "",
            eventID: registrantData.eventID,
          };
          switch (sponsorship) {
            case "Presidents Dinner":
              obj.sponsorType = "Presidents_Dinner";
              notifyBackend(obj);
              break;
            case "Presidents Reception":
              obj.sponsorType = "Presidents_Reception";
              notifyBackend(obj);
              break;
            case "Welcome Reception":
              obj.sponsorType = "Welcome_Reception";
              notifyBackend(obj);
              break;
            case "Wristband Sponsor":
              obj.sponsorType = "Wristband_Sponsor";
              notifyBackend(obj);
              break;
            case "Room Key Sponsor":
              obj.sponsorType = "Room_Key_Sponsor";
              notifyBackend(obj);
              break;
            default:
              break;
          }
        }
      );
    }
  };

  //^ this is an example of how to loop through the custom_inputs_obj returned
  //^ from the database.
  // for (const [key, value] of Object.entries(obj.custom_inputs_obj)) {
  //   console.log(key, value);
  // }
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "5em",
        }}
      >
        <Button
          disabled={isDisabled}
          backgroundColor={"#FFA559"}
          shadowColor={"#454545"}
          title={"Register"}
          onClick={submitHandler}
        />
      </div>
    </>
  );
};

export default RegisterButton;
